function IterationGoal() {
  return `
## 🎯 Sprint Goal
### What was the sprint goal?
- Sprint_goal

### Was it achieved?
- Yes_or_No

### What are the reasons why the sprint goal was not achieved?
- Reason1
- Reason2

### Were the goals of the last 2 previous sprints achieved?
> This is to get an idea of the tendency. You'll want to do adjustments when you repeatedly miss the sprint goals.

- Previous_Sprint_Yes_or_No
- Previous_Previous_Sprint_Yes_or_No`;
}

export default IterationGoal;
